import watermark from '@/components/WaterMark/watermark';

const STORAGE_KEY = 'fcops_dark_mode';

export function getStoredDarkMode() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function applyDarkMode(isDark) {
  const root = document.documentElement;
  if (isDark) {
    root.classList.add('dark-mode');
  } else {
    root.classList.remove('dark-mode');
  }
}

export function persistDarkMode(isDark) {
  try {
    localStorage.setItem(STORAGE_KEY, isDark ? '1' : '0');
  } catch (e) {
    /* ignore */
  }
  applyDarkMode(isDark);
  if (typeof watermark.refresh === 'function') {
    watermark.refresh();
  }
}

export function initThemeFromStorage() {
  applyDarkMode(getStoredDarkMode());
}
